import React from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import classes from "./Auth.module.css";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { useTranslation, withTranslation } from 'react-i18next'
import { Form, Input, Button} from "antd";
import { authRegister } from "../../network/auth";
import { useMutation } from "@tanstack/react-query";
import cogoToast from "cogo-toast";

const Register = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const { mutate: onRegister, isPending } = useMutation({
    mutationFn: (formData) => authRegister(formData),
    onSuccess: (data) => {
      if (data?.false !== false) {
        cogoToast.success(t("auth.registerSuccess"), { position: "top-right" });
        navigate("/login");
      } else {
        cogoToast.warn(t("auth.incorrectData"), { position: "top-right" });
      }
    },
    onError: () => {
      cogoToast.warn(t("Something went wrong"), { position: "top-right" });
    }
  });

  const onFinish = (values) => {
    onRegister(values);
  };


  if (localStorage.getItem("token")) {
    return <Navigate to="/login" />;
  }

  return (
    <Container>
      <Row>
        <Col className="mx-auto py-5" xl={8} lg={8} md={8} sm={12}>
          <h4 className={`${classes["auth-header-title"]}`}>

            {t('signup1')}
          </h4>
          <h6 className={`${classes["auth-subheader-title"]}`}>
            {t('signup2')}{" "}
            <Link to="/login" className={`${classes["register-link"]}`}>
              {t('login')}
            </Link>{" "}

            {t('login7')}
          </h6>

          <Card className={`${classes["custom-card"]}`}>
            <Card.Body>
              <Row>
                <Col></Col>
                <Col xl={8}>
                  <Form form={form} name="register" onFinish={onFinish} layout="vertical">
                    <Form.Item
                      name="name"
                      label={t('auth.name')}
                      required={false}
                      rules={[
                        { required: true, message: t('auth.nameValidationRequired'), whitespace: true },
                      ]}
                    >
                      <Input className="h-[38px]" placeholder={t("auth.namePlaceholder")} />
                    </Form.Item>
                    <Form.Item
                      name="email"
                      label={t('auth.email')}
                      required={false}
                      rules={[
                        { type: 'email', message: t('auth.emailValidation') },
                        { required: true, message: t('auth.emailValidationRequired') }
                      ]}
                    >
                      <Input className="h-[38px]" placeholder={t("auth.emailPlaceholder")} />
                    </Form.Item>
                    <Form.Item
                      name={"phone"}
                      label={t('auth.phone')}
                      colon={false}
                      required={false}
                      hasFeedback

                    >
                      <Input className="h-[38px]" placeholder={t("auth.phone")} />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      label={t("password")}
                      required={false}
                      rules={[
                        { required: true, message: t('auth.passwordValidationRequired') }
                      ]}
                      hasFeedback
                    >
                      <Input.Password className="h-[38px]" placeholder={t("auth.passwordPlaceholder")} />
                    </Form.Item>

                    <Button
                      type="primary"
                      loading={isPending}
                      htmlType="submit"
                      className={`${classes["auth-button"]}`}
                    >
                      {t("auth.signUp")}
                    </Button>
                  </Form>
                </Col>
                <Col></Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}


export default withTranslation()(Register);

